<section class="page-shell">
  <header class="page-header">
    <div>
      <h4>Transactions Universign</h4>
      <p>Consultez les transactions en attente et annulez-les lorsque nécessaire.</p>
    </div>
  </header>

  <article class="panel dbw-card dbw-card--xl filters">
    <oui-textfield label="Depuis" type="date" [value]="since()" (valueChange)="onSinceChange($event ? $event.toString() : '')"></oui-textfield>
    <oui-textfield label="Jusqu’au" type="date" [value]="until()" (valueChange)="onUntilChange($event ? $event.toString() : '')"></oui-textfield>
    <oui-button (click)="load()" [disabled]="loading()">Rechercher</oui-button>
    @if (canCancel()) {
      <oui-textfield class="reason-field" label="Motif d’annulation" [value]="reason()" (valueChange)="onReasonChange($event ? $event.toString() : '')"></oui-textfield>
    }
  </article>

  @if (error()) {
    <dbw-state-card appearance="error" title="Chargement impossible"><p>{{ error() }}</p></dbw-state-card>
  }
  @if (loading()) {
    <dbw-state-card appearance="loading" [compact]="true"><p>Chargement des transactions Universign.</p></dbw-state-card>
  }
  @if (!loading() && !error()) {
    <article class="panel dbw-card dbw-card--xl">
      <h5>Transactions en attente</h5>
      @if (transactions().length === 0) {
        <p>Aucune transaction Universign en attente n’a été retournée pour cette période.</p>
      } @else {
        <div class="table-scroll"><table><thead><tr><th>Transaction</th><th>Statut</th><th>Création</th><th>Description</th><th>Signataires</th><th>Demandeur</th><th>Id externe</th><th>Action</th></tr></thead><tbody>
          @for (transaction of transactions(); track transaction.transactionId) {
            <tr><td class="transaction-id">{{ transaction.transactionId }}</td><td>{{ transaction.status }}</td><td>{{ transaction.creationDate ? (transaction.creationDate | date: 'dd/MM/yyyy HH:mm') : '—' }}</td><td>{{ transaction.description || '—' }}</td><td>@if (transaction.signers.length === 0) { — } @for (signer of transaction.signers; track $index) { <div class="person">{{ signer.firstName }} {{ signer.lastName }}<br><small>{{ signer.email || '—' }} · {{ signer.status || '—' }} · {{ signer.actionDate ? (signer.actionDate | date: 'dd/MM/yyyy HH:mm') : '—' }}</small></div> }</td><td>@if (transaction.initiator; as initiator) { {{ initiator.firstName }} {{ initiator.lastName }}<br><small>{{ initiator.email || '—' }}</small> } @else { — }</td><td>{{ transaction.customerId || '—' }}</td><td>@if (canCancel()) { <oui-button color="error" (click)="cancel(transaction)" [disabled]="cancellingTransactionId() !== undefined">Annuler</oui-button> }</td></tr>
          }
        </tbody></table></div>
      }
    </article>
  }
</section>
